module.exports = __webpack_public_path__ + "static/media/iStock-514996764.e5a86e6c.jpg";